import { render, staticRenderFns } from "./roomList.vue?vue&type=template&id=08fa3389&scoped=true&"
import script from "./roomList.vue?vue&type=script&lang=js&"
export * from "./roomList.vue?vue&type=script&lang=js&"
import style0 from "./roomList.vue?vue&type=style&index=0&id=08fa3389&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa3389",
  null
  
)

export default component.exports